module.exports = __webpack_public_path__ + "img/modal-title.61d3648c.png";